import React from 'react';
import Hero from './Hero';
import Stats from './Stats';
import Education from './Education';
import Pricing from './Pricing';
import Awards from './Awards';
import OpenAccount from '../OpenAccount';
import Footer from '../Footer';
import Navbar from "../Navbar";

function HomePage() {
    return ( 
        <>
        
        <Hero/>
        <Awards/>
        <Stats/>
         <Pricing/>
        <Education/>
        <OpenAccount/>
       
        </>
        
     );
}

export default HomePage;